import { YodleeInstitution } from '@/components/yodlee/FastLinkv2';
import HouseRounded from '@mui/icons-material/HouseRounded';
import DirectionsCarRounded from '@mui/icons-material/DirectionsCarRounded';
import AttachMoneyRounded from '@mui/icons-material/AttachMoneyRounded';
import DiamondRounded from '@mui/icons-material/DiamondRounded';
import CategoryUtility, { ClassificationItem } from './categories.utility';
import { Classification } from '@/store/classificationsApi';
import { ClassificationIds, SubClassificationIds } from '@/utils/enums';

export interface ManualAccountType extends ClassificationItem {
  icon: React.ReactNode;
}

export type IInstitution = {
  label: string;
  value: string;
  url: string;
  isPopular?: boolean;
  isDisabled?: boolean;
  disabledMessage?: string | null;
  institution?: YodleeInstitution;
};

export const getManualAccountTypes = (
  classifications: Classification[],
): ManualAccountType[] => {
  if (!classifications.length) {
    return [];
  }

  const iconSize = { width: 32, height: 32 };

  const mostCommonAccountTypes = [
    {
      id: ClassificationIds.REAL_ESTATE,
      icon: (
        <HouseRounded
          color='action'
          sx={iconSize}
        />
      ),
    },
    {
      // "Vehicle" is a sub-classification in the backend taxonomy. For the "Add vehicle" shortcut,
      // we select Personal Property as the main classification and preselect Vehicle as the subtype.
      id: ClassificationIds.PERSONAL_PROPERTY,
      icon: (
        <DirectionsCarRounded
          color='action'
          sx={iconSize}
        />
      ),
      presetSubClassificationId: SubClassificationIds.VEHICLE,
      overrideName: 'Vehicle',
      uiKey: 'vehicle',
    },
    {
      id: ClassificationIds.PRIVATE_INVESTMENT,
      icon: (
        <AttachMoneyRounded
          color='action'
          sx={iconSize}
        />
      ),
    },
    {
      id: ClassificationIds.PERSONAL_PROPERTY,
      icon: (
        <DiamondRounded
          color='action'
          sx={iconSize}
        />
      ),
      uiKey: 'personalProperty',
    },
  ].flatMap((x) => {
    const base = CategoryUtility.getClassificationByClassificationId({
      classifications,
      classificationId: x.id,
    });
    if (!base) return [];
    return [
      {
        ...base,
        Name:
          'overrideName' in x && x.overrideName ? x.overrideName : base.Name,
        uiKey:
          'uiKey' in x && x.uiKey ? x.uiKey : String(base.ClassificationId),
        presetSubClassificationId:
          'presetSubClassificationId' in x
            ? x.presetSubClassificationId
            : undefined,
        icon: x.icon,
      },
    ];
  });

  return mostCommonAccountTypes;
};

//TODO: Get real recommendations from API
export const RECOMMENDATIONS: Omit<
  IInstitution,
  'isPopular' | 'institution'
>[] = [
  {
    label: 'Chase',
    value: 'chase_bank',
    url: '',
  },
  {
    label: 'PNC Bank',
    value: 'pnc_bank',
    url: '',
  },
  {
    label: 'Wells Fargo',
    value: 'wells_fargo',
    url: '',
  },
  {
    label: 'TD Bank',
    value: 'td_bank',
    url: '',
  },
  {
    label: 'Citibank',
    value: 'citi_bank',
    url: '',
  },
  {
    label: 'Bank of America',
    value: 'boa',
    url: '',
  },
  {
    label: 'Capital One',
    value: 'capital_one',
    url: '',
  },
];
